import { t } from 'ttag'
import { useState } from 'react'

import { Loader } from '@h2/components/loading/loader'
import { Flex } from '@h2/components/layout/flex'
import { Link } from '@h2/common/components/link'
import { Grid } from '@h2/components/containers/grid'
import { Text } from '@h2/components/typography/text'
import { Pagination } from '@h2/components/containers/grid/pagination'
import { DESC } from '@h2/components/containers/grid/constants'

import { RedX, GreenCheck, GrayMinus } from '../commonComponents/icons'

const AssignmentListing = ({
  isFetching,
  results,
  totalResults,
  setPageNum,
  pageNum,
  numPerPage,
  setNumPerPage
}) => {
  const [sortOrder] = useState(DESC)
  const [sortBy] = useState('user.name')
  const options = {
    isSearchQueryHighlighted: true,
    disableFilters: true
  }
  const columns = [
    {
      id: 'user.name',
      label: t`Name`,
      sortable: false
    },
    {
      id: 'name',
      label: t`Assignment`,
      sortable: false
    },
    {
      id: 'dateCreated',
      label: t`Date Assigned`,
      width: '150px',
      sortable: false,
      render({ dateCreated }) {
        return new Date(dateCreated).toLocaleDateString()
      }
    },
    {
      id: 'dateReadSummary',
      label: t`Started`,
      labelAlign: 'center',
      width: '110px',
      sortable: false,
      render({ dateReadSummary }) {
        return (
          <Flex justifyContent="center">
            {dateReadSummary ? <GreenCheck /> : <RedX />}
          </Flex>
        )
      }
    },
    {
      id: 'dateSubmitted',
      label: t`Completed`,
      labelAlign: 'center',
      width: '110px',
      sortable: false,
      render({ dateSubmitted, dateReadSummary }) {
        return (
          <Flex justifyContent="center">
            {dateSubmitted ? <GreenCheck /> : dateReadSummary ? <RedX /> : <GrayMinus />}
          </Flex>
        )
      }
    },
    {
      id: 'dateApproved',
      label: t`Approved`,
      labelAlign: 'center',
      width: '110px',
      sortable: false,
      render({ dateApproved, dateSubmitted }) {
        return (
          <Flex justifyContent="center">
            {dateApproved ? <GreenCheck /> : dateSubmitted ? <RedX /> : <GrayMinus />}
          </Flex>
        )
      }
    },
    {
      id: 'id',
      label: t`Action`,
      sortable: false,
      width: '95px',
      render({ id }) {
        return (
          <Link
            href={`/management/assignments/${id}`}
            variant="outlined"
            isFullWidth={true}>
            {t`View`}
          </Link>
        )
      }
    }
  ]

  if (isFetching) {
    return <Loader />
  }

  if (!results || !results.length) {
    return (
      <Text margin="60px" size="large" align="center">
        {t`There are no assignments that match the specified criteria.`}
      </Text>
    )
  }

  return (
    <>
      <Grid
        data={results}
        columns={columns}
        options={options}
        rowIdKey="id"
        defaultSortBy={sortBy}
        defaultPageSize={100}
        defaultSortOrder={sortOrder}
        isRowSelectable={false}
        isPagerVisible={false}
      />
      <Pagination
        page={pageNum}
        pageSize={numPerPage}
        total={totalResults}
        onChangePage={setPageNum}
        onChangePageSize={setNumPerPage}
      />
    </>
  )
}

export { AssignmentListing }
